<template>
    <el-dropdown size="large" ref="dropdown" trigger="click">
        <div class="flex items-center gap-10 cursor-pointer">
            <el-avatar :src="avatar" :size="24" :show-timeout="300" />
            {{ userState.nickname }}
            <el-icon class="el-icon--right"><arrow-down /></el-icon>
        </div>

        <template #dropdown>
            <div class="px-12px rounded-8px" @click="logout">
                <div class="my-16px !font-400 !text-14px rounded-4px reset-btn h-32px flex-center !border-0 cursor-pointer">
                    <el-button link class="whitespace-nowrap">退出登录</el-button>
                </div>
            </div>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import { clear } from '@/utils/localStorage';
import { removeCookies } from '@/utils/cookies';
import avatar from '@/assets/svgs/avatar.svg';
import { ArrowDown } from '@element-plus/icons-vue';
const { clearUserInfo, userState } = useStore('user');
const router = useRouter();
const logout = () => {
    clearUserInfo();
    clear();
    removeCookies(); // 清除所有 cookie
    router.push('/home');
};
</script>

<style lang="scss" scoped>
.reset-btn {
    border-color: #bec3cd;

    :deep(.el-button) {
        color: #3e4a54 !important;
    }
    &:hover {
        :deep(.el-button) {
            color: #2554ca !important;
        }
        border-color: #2554ca;
        .el-icon {
            fill: #2554ca !important;
        }
    }
    &:active {
        .el-icon {
            fill: #fff !important;
        }
        :deep(.el-button) {
            color: #fff !important;
        }
        border-color: transparent;
        background: #2554ca;
    }
}
</style>
